import { jsx as _jsx } from "react/jsx-runtime";
import s from './container.module.scss';
export const Container = ({ children, className }) => (_jsx("div", { className: `${s.container} ${className || ''}`, children: children }));
